import { combineReducers } from 'redux'

import { createReducer } from 'helpers/ReducerUtil'
import P from 'helpers/predicates'
import * as R from 'ramda'

import {
  UPDATE_PRODUCT_DETAILS,
  CLEAR_PRODUCT_DETAILS
} from './constants'

const updateProductDetailId = (prev, { id }) => P.isNotNil(id)
  ? id
  : prev

const detailIdReducer = createReducer(null, {
  [CLEAR_PRODUCT_DETAILS]: () => null,
  [UPDATE_PRODUCT_DETAILS]: updateProductDetailId
})

export default combineReducers({
  detailId: detailIdReducer
})
